// Catálogos: marcas, modelos, proveedores, tipos de solicitud/falla/solución,
// categorías y mensajes rápidos.

import { api } from "./http";

export type Marca = {
  id: number;
  nombre: string;
  activo: boolean;
  notas: string | null;
  proveedor_id: number | null;
  proveedor_nombre: string | null;
  created_at: string;
};

export type ProveedorContacto = {
  id: number;
  proveedor_id: number;
  nombre: string;
  email: string;
  telefono: string | null;
  es_principal: boolean;
  activo: boolean;
};

// Mismo shape que TipoSolicitud (catálogos gemelos: solicitud y falla).
export type TipoFalla = TipoSolicitud;

export type TipoSolicitud = {
  id: number;
  nombre: string;
  notas: string | null;
  activo: boolean;
  created_at: string;
};

export type TipoSolucion = {
  id: number;
  nombre: string;
  descripcion: string | null;
  activo: boolean;
  orden: number;
  created_at: string;
};

export type Categoria = {
  id: number;
  slug: string;
  nombre: string;
  activo: boolean;
  orden: number;
  created_at: string;
};

export type Proveedor = {
  id: number;
  nombre: string;
  notas: string | null;
  activo: boolean;
  created_at: string;
  contactos: ProveedorContacto[];
};

export type ProveedorIn = {
  nombre: string;
  notas?: string | null;
};

export type ContactoIn = {
  nombre: string;
  email: string;
  telefono?: string | null;
  es_principal?: boolean;
};

export type Modelo = {
  id: number;
  marca_id: number;
  marca_nombre: string;
  nombre: string;
  activo: boolean;
  notas: string | null;
  creado_por_nombre: string | null;
  creado_el: string | null;
};

export function listarMarcas() {
  return api.get<Marca[]>("/api/catalogos/marcas");
}

// Las categorías ahora son dinámicas (tabla categorias_caso, editable en
// Configuración → Categorías). En el caso se guarda el `slug` de la categoría.
export type TipoCategoria = string;

export type PlantillaNotif = {
  id: number;
  texto: string;
  activo: boolean;
  created_at: string;
};
